export default "__VITE_ASSET__Du0YZiKE__"